import classNames from 'classnames';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { buildDataSlug } from 'utilities/weather-warnings/warnings.js';
import { WarningItemContent } from '../../utilities/weather-warnings/warning-item-content.js';
import { ManageUniqueWarningSlug } from './utils/manageSlug.js';

export const PanelBodyLandItem = ({
  warning,
  isLast,
  classes,
}: {
  warning: IWarning;
  isLast: boolean;
  classes?: string;
}) => {
  const dataSlug = buildDataSlug(warning);
  const isHighlighted = ManageUniqueWarningSlug(dataSlug);

  // 2021-08-26T21:00:00+12:00 2021-08-27T21:00:00+12:00
  return (
    <li className={classNames('ArticleList-item warning-panel', { 'u-bB-0': isLast }, classes)}>
      <div className="Grid Grid--withGutter">
        <div className="Grid-cell u-width1of1">
          <div className={classNames('warning-body-item', { active: isHighlighted })}>
            <WarningItemContent warning={warning} />
          </div>
        </div>
      </div>
    </li>
  );
};
